module.exports = __webpack_public_path__ + "img/ground_3.151b8258.png";